import React from "react";
import "../styles.css";
import { CreditInstrument } from "../types";
import { formateDate } from "../hook/ScreenHelper";
import { COLORS } from "../constants";

interface ViewSimahDataProps {
  data?: CreditInstrument[];
}


const CI_COLUMNS: {
  header: string;
  key: keyof CreditInstrument;
}[] = [
  { header: "CRDTR", key: "creditorName" },
  { header: "BANK", key: "creditorName" }, 

  { header: "PRD", key: "productType" },
  { header: "PLN", key: "productType" },   
  { header: "ACC_NO", key: "accountNumber" },
  { header: "LIMIT", key: "creditLimit" },
  { header: "ISSU_DT", key: "issueDate" },
  { header: "PROD_EXP_DT", key: "expiryDate" },
  { header: "STATUS", key: "status" },
  { header: "CLSD_DT", key: "closedDate" },
  { header: "TNR", key: "tenure" },
  { header: "FRQ", key: "frequency" },
  { header: "INSTL", key: "installmentAmount" },
  { header: "SAL", key: "salaryAssignment" },
  { header: "CUB", key: "pastDueBalance" },
  { header: "ODB", key: "outstandingBalance" },
  { header: "LAST_AMT_PD", key: "lastAmountPaid" },
  { header: "LAST_PAY_DT", key: "lastPaymentDate" },
  { header: "AS_OF_DT", key: "asOfDate" },
  { header: "NXT_DU_DT", key: "nextDueDate" },
  { header: "SUMMRY", key: "summary" },
  { header: "INSTL_New", key: "newInstallment" },
  { header: "FO", key: "financeOperation" },
];

/**
 * Date fields that require formatting
 */
const CI_DATE_COLUMNS: (keyof CreditInstrument)[] = [
  "issueDate",
  "expiryDate",
  "closedDate",
  "lastPaymentDate",
  "asOfDate",
  "nextDueDate",
];

const ViewSimahData: React.FC<ViewSimahDataProps> = ({ data = [] }) => {
  return (
    <div className="table-responsive" style={{ marginTop: 10 }}>
      <table
        className="table text-center table-border spaced-table"
        style={{ minWidth: "100%" }}
      >
        {/* HEADER */}
        <thead style={{ background: COLORS.BG_LIGHTER }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {CI_COLUMNS.map((col, index) => (
              <th key={`${col.header}-${index}`}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {data.map((row, rowIndex) => (
            <tr key={row.accountNumber ?? rowIndex}>
              {CI_COLUMNS.map((col, colIndex) => {
                const value = row[col.key];

                const displayValue = CI_DATE_COLUMNS.includes(col.key)
                  ? formateDate(value)
                  : value;

                return (
                  <td key={`${col.header}-${colIndex}`}>
                    {displayValue ?? "-"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewSimahData;
